<template>
  <div class="box  box--gray">

    <ul class="box__list">
      <li v-for="item in cart.items" class="box__list-item">
        <div class="box__item-title">
          {{ item.product.title }}
        </div>
        <span>{{ item.price_with_tax }}</span>
      </li>
    </ul><!-- ./box__list -->

    <div class="box__section">
      <ul class="box__list">
        <li class="box__list-item">
          <div>{{ in18['page_summary_product_quantity'] }}</div>
          <span>{{ cart.total_quantity }}</span>
        </li>
        <li class="box__list-item">
          <div>{{ in18['page_summary_price_without_tax'] }}</div>
          <span>{{ cart.formatted_total_price }}</span>
        </li>
        <li class="box__list-item">
          <div>{{ in18['page_summary_tax'] }} ({{ cart.tax_rate }}%)</div>
          <span>{{ cart.formatted_tax_price }}</span>
        </li>
      </ul>
    </div><!-- ./box__section -->

    <div v-if="cart.shipping_method" class="box__section">
      <ul class="box__list">
        <li class="box__list-item">
          <div>{{ in18['page_summary_shipping'] }}</div>
          <span>
            {{ cart.formatted_shipping_price_with_tax }}
          </span>
        </li>
        <li class="box__list-item">
          <div class="fw-500 text-gray-dark">
            {{ cart.shipping_method.title }}
          </div>
        </li>
      </ul>
    </div><!-- ./box__section -->

    <div v-if="cart.payment_surcharge_price_with_tax > 0" class="box__section">
      <ul class="box__list">
        <li class="box__list-item">
          <div>{{ in18['page_summary_payment_surcharge'] }}</div>
          <span>
            {{ cart.formatted_payment_surcharge_price_with_tax }}
          </span>
        </li>
      </ul>
    </div><!-- ./box__section -->

    <div v-if="cart.coupon_total_price_with_tax > 0" class="box__section">
      <ul class="box__list">
        <li class="box__list-item">
          <div>{{ in18['page_summary_discount_price_wit_tax'] }}</div>
          <span class="discount_total_price">
            - {{ cart.formatted_coupon_total_price_with_tax }}
          </span>
        </li>
      </ul>
    </div><!-- ./box__section -->

    <div class="box__section">
      <ul class="box__list">
        <li class="box__list-item box__list-item--accent">
          <div class="text-red">{{ in18['page_summary_total_price'] }}</div>
          <div><b class="text-red text-xl">{{ cart.formatted_total_price_with_tax }}</b></div>
        </li>
      </ul>
    </div><!-- ./box__section -->

  </div><!-- ./box -->
</template>

<script>

export default {

  name: "CheckoutSummary",

  props: {
    cart: {
      type: Object
    },
    in18: {
      type: Object
    },
  },

};
</script>

<style>
.text-red {
  color: #e53935;
  font-weight: 500;
}

.text-xl {
  font-size: 1.5rem;
  font-weight: bold;
}

.total-highlight {
  background-color: #fff0f0;
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid #e53935;
}
</style>